<template>
  <v-card data-testid="task-info-card" class="task-info-card shadow-off" v-if="allowedTaskTypes">
    <v-row data-testid="task-info-card__metrics-row" dense>
      <!-- Trial Balance -->
      <v-col data-testid="task-info-card__metric-col-trial-balance" class="pa-1 width-20">
        <v-card data-testid="task-info-card__trial-balance-card" class="rounded-lg pa-4 align-start info-card" outlined>
          <div data-testid="task-info-card__trial-balance-header" class="d-flex align-center justify-space-between mb-1">
            <span data-testid="task-info-card__trial-balance-label" class="label grey--text font-size-xm">Trial Balance</span>
            <!-- <v-icon data-testid="task-info-card__trial-balance-info-icon" class="ml-1">mdi-information</v-icon> -->
          </div>
          <div data-testid="task-info-card__trial-balance-value" class="font-weight-bold font-size-lg">
            {{ formatNumber(tbtotals) }}
          </div>
        </v-card>
      </v-col>
      <!-- Recon Amount -->
      <v-col data-testid="task-info-card__metric-col-recon-amount" class="pa-1 width-20">
        <v-card data-testid="task-info-card__recon-amount-card" class="rounded-lg pa-4 align-start info-card" outlined>
          <div data-testid="task-info-card__recon-amount-header" class="d-flex align-center justify-space-between mb-1">
            <span data-testid="task-info-card__recon-amount-label" class="label grey--text font-size-xm">Recon Amount</span>
            <!-- <v-icon data-testid="task-info-card__recon-amount-info-icon" class="ml-1">mdi-information</v-icon> -->
          </div>
          <div data-testid="task-info-card__recon-amount-value" class="font-weight-bold font-size-lg">
            {{ formatNumber(reconAmount) }}
          </div>
        </v-card>
      </v-col>
      <!-- Explained Difference -->
      <v-col data-testid="task-info-card__metric-col-explained-diff" class="pa-1 width-20">
        <v-card data-testid="task-info-card__explained-diff-card" class="rounded-lg pa-4 align-start info-card" outlined>
          <div data-testid="task-info-card__explained-diff-header" class="d-flex align-center justify-space-between mb-1">
            <span data-testid="task-info-card__explained-diff-label" class="label grey--text font-size-xm">Explained Difference</span>
            <!-- <v-icon data-testid="task-info-card__explained-diff-info-icon" class="ml-1">mdi-information</v-icon> -->
          </div>
          <div data-testid="task-info-card__explained-diff-value" class="font-weight-bold font-size-lg">
            {{ formatNumber(explainedDiff) }}
          </div>
        </v-card>
      </v-col>
      <!-- Unexplained Difference -->
        <v-col data-testid="task-info-card__metric-col-unexplained-diff" class="pa-1 width-20">
          <v-card
            data-testid="task-info-card__unexplained-diff-card"
            class="rounded-lg pa-4 align-start"
            :class="unexplainedDiff === 0 ? 'unexplained-difference-green' : 'unexplained-difference-red'"
            outlined
          >
            <div data-testid="task-info-card__unexplained-diff-header" class="d-flex align-center justify-space-between mb-1">
              <span
                data-testid="task-info-card__unexplained-diff-label"
                class="label font-size-xm"
                :class="unexplainedDiff === 0 ? 'green--text' : 'red--text'"
              >Unexplained Difference</span>
              <!-- <v-icon
                data-testid="task-info-card__unexplained-diff-info-icon"
                class="ml-1"
                :class="unexplainedDiff === 0 ? 'green--text' : 'red--text'"
              >mdi-information</v-icon> -->
            </div>
            <div
              data-testid="task-info-card__unexplained-diff-value"
              class="font-weight-bold font-size-lg"
              :class="unexplainedDiff === 0 ? 'green--text' : 'red--text'"
            >
              {{ formatNumber(unexplainedDiff) }}
            </div>
          </v-card>
        </v-col>
      <!-- Threshold -->
      <v-col data-testid="task-info-card__metric-col-threshold" class="pa-1 width-20">
        <v-card data-testid="task-info-card__threshold-card" class="rounded-lg pa-4 align-start info-card" outlined>
          <div data-testid="task-info-card__threshold-header" class="d-flex align-center justify-space-between mb-1">
            <span data-testid="task-info-card__threshold-label" class="label grey--text font-size-xm">Threshold</span>
            <!-- <v-icon data-testid="task-info-card__threshold-info-icon" class="ml-1">mdi-information</v-icon> -->
          </div>
          <div data-testid="task-info-card__threshold-value" class="font-weight-bold font-size-lg">
            {{ formatNumber(thresholdDisplay) }}
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { getTbTotals, calculateScheduleAmount, calculateExplainedDifference, calculateUnexplainedDifference } from '../../../../utils/utils';

export default {
  name: 'TaskInfoCard',
  props: {
    task: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      taskTypes: this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION
    };
  },
  computed: {
      allowedTaskTypes() {
        return this.taskTypes === this.task.task_type;
      },
    viewtaskdata() {
        // Use the full task object as viewtaskdata
        return this.task || {};
      },
      tbtotals() {
        return getTbTotals(this.viewtaskdata);
      },
      reconAmount() {
        return calculateScheduleAmount(this.viewtaskdata);
      },
      explainedDiff() {
        return calculateExplainedDifference(this.viewtaskdata);
      },
      unexplainedDiff() {
        return calculateUnexplainedDifference(this.viewtaskdata);
      },
      thresholdDisplay() {
        if (!this.viewtaskdata) return "N/A";
        const v = this.viewtaskdata.threshold;
        return v === null || v === undefined || v === '' ? "N/A" : v;
      }
  },
  methods: {
      formatNumber(n) {
        // Always format as number, fallback to 0
        if (typeof n !== 'number' || isNaN(n)) n = Number(n) || 0;
        // Show negative numbers in parentheses (US accounting style)
        if (n < 0) {
          return '(' + Math.abs(n).toLocaleString('en-US', { maximumFractionDigits: 0 }) + ')';
        }
        return n.toLocaleString('en-US', { maximumFractionDigits: 0 });
      }
  }
}
</script>

<style scoped>
/* .task-info-card {
  border-radius: 4px;
  background: #fff;
  box-shadow: 0px 2px 16px 0 rgba(44, 62, 80, 0.08) !important;
} */

.info-card {
  border-radius: 8px;
  border: 1px solid var(--color-border-light);
  background: var(--color-bg-light);
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.06) !important;
}


.unexplained-difference-red {
  border-radius: 8px;
  border: 1px solid var(--border-danger-default, #FBEAEA);
  background: var(--background-danger-default, #FDF4F4);
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.06);
}

.unexplained-difference-green {
  border-radius: 8px;
  border: 1px solid #E6F4EA;
  background: #F4FBF7;
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.08);
}

.label {
  font-weight: 500;
  letter-spacing: 0.5px;
}
</style>
